import * as neway from 'api/neway';
import { AFFILIATES_GET, AFFILIATES_GET_DETAILS, AFFILIATE_GET, AFFILIATE_GET_DETAILS, AFFILIATE_GET_BY_SLUG, AFFILIATE_GET_BY_AFFILIATION_CODE } from '../constants/affiliates';

export function getAffiliates() {
    return async dispatch => {
        const affiliates = await neway.getAffiliates();
        dispatch({ type: AFFILIATES_GET, payload: { affiliates } });
        return affiliates;
    };
}

export function getAffiliatesDetails() {
    return async dispatch => {
        const affiliates = await neway.getAffiliates({ details: true });
        dispatch({ type: AFFILIATES_GET_DETAILS, payload: { affiliates } });
        return affiliates;
    };
}

export function getAffiliate(affiliateId) {
    return async dispatch => {
        const affiliate = await neway.getAffiliate(affiliateId);
        dispatch({ type: AFFILIATE_GET, payload: { affiliate } });
        return affiliate;
    };
}

export function getAffiliateBySlug(slug) {
    return async dispatch => {
        const affiliate = await neway.getAffiliateBySlug(slug);
        dispatch({ type: AFFILIATE_GET_BY_SLUG, payload: { affiliate } });
        return affiliate;
    };
}

export function getAffiliateByAffiliateCode(affiliateCode) {
    return async dispatch => {
        const affiliate = await neway.getAffiliateByAffiliateCode(affiliateCode);
        dispatch({ type: AFFILIATE_GET_BY_AFFILIATION_CODE, payload: { affiliate } });
        return affiliate;
    };
}

export function getAffiliateDetails(affiliateId) {
    return async dispatch => {
        const affiliate = await neway.getAffiliate(affiliateId, { details: true });
        dispatch({ type: AFFILIATE_GET_DETAILS, payload: { affiliate } });
        return affiliate;
    };
}


export function getAffiliateProduct(affiliateId) {
    return async dispatch => {
        const affiliate = await neway.getAffiliateProduct(affiliateId, { details: true });
        dispatch({ type: AFFILIATE_GET_DETAILS, payload: { affiliate } });
        return affiliate;
    };
}
